import { useState } from "react";

const CustomTooltip = ({ 
  children, 
  content, 
  className = "",
  tooltipClassName = ""
}) => {
  const [hoveredData, setHoveredData] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0, showBelow: false });

  const handleMouseEnter = (data, event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const tooltipWidth = 200;
    const tooltipHeight = 120;
    
    // Calculate if tooltip should be above or below
    const spaceAbove = rect.top;
    const spaceBelow = viewportHeight - rect.bottom;
    const shouldShowBelow = spaceAbove < tooltipHeight + 20 || spaceBelow > spaceAbove;
    
    // Calculate horizontal position to keep tooltip in viewport
    let x = rect.left + rect.width / 2;
    const halfTooltipWidth = tooltipWidth / 2;
    
    if (x - halfTooltipWidth < 10) {
      x = halfTooltipWidth + 10;
    } else if (x + halfTooltipWidth > viewportWidth - 10) {
      x = viewportWidth - halfTooltipWidth - 10;
    }
    
    setTooltipPosition({
      x,
      y: shouldShowBelow ? rect.bottom + 10 : rect.top - 10,
      showBelow: shouldShowBelow
    });
    setHoveredData(data);
  };

  const handleMouseLeave = () => {
    setHoveredData(null);
  };

  return (
    <>
      {children({ 
        onMouseEnter: handleMouseEnter, 
        onMouseLeave: handleMouseLeave 
      })}
      
      {/* Custom Tooltip */}
      {hoveredData && (
        <div
          className={`fixed z-50 w-50 rounded-md border bg-white shadow-lg text-xs ${tooltipClassName}`}
          style={{
            left: tooltipPosition.x - 100,
            top: tooltipPosition.y,
            transform: tooltipPosition.showBelow 
              ? 'translateY(0)' 
              : 'translateY(-100%)',
            maxWidth: '300px',
            minWidth: '180px'
          }}
        >
          {content(hoveredData)}
        </div>
      )}
    </>
  );
};

export default CustomTooltip;